import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import {
  alert as state
} from '../store';

export default createReducer(state, {
  SET_MODAL_TYPE: (state, { data }) => Immutable({ ...state, modalType: data }),
  SET_IS_MODAL_OPEN: (state, { data }) => Immutable({ ...state, isModalOpen: data }),
  SET_MODAL_CONFIRM_ACTION: (state, { data }) => Immutable({ ...state, modalConfirmAction: data }),
  SET_MODAL_ALERTING_MESSAGE:
    (state, { data }) => Immutable({ ...state, modalAlertingMessage: data }),
  SET_SHOW_NATIONAL_SURVEY_PROMPT:
    (state, { data }) => Immutable({ ...state, showNationalSurveyPrompt: data }),
  SET_MODAL_CONFIRM_ACTION_CALLBACK:
    (state, { data }) => Immutable({ ...state, modalConfirmActionCallback: data }),
});
